import axios from 'axios';
import { startAction, stopAction } from 'src/actions/uiActions';
import authService from './authService';

const { API_BASE_URL } = window.runtimeConfig;

// Sets up a function to logout the current user,
// for example, when the server terminates the session
// due to inactivity.
let logoutOnError = null;
let dispatch = null;

export function initializeAxios({ onLogout, dispatchFunc }) {
  logoutOnError = onLogout;
  dispatch = dispatchFunc;
}

const callAxios = async (method, url, data, type) => {
  dispatch(startAction());
  let token = authService.getAccessToken();
  if (token && authService.getTokenExpiration(token) < 30) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/tokens/refresh`, authService.getTokenObj());
      if (response.status === 200) {
        const tokenObj = response.data;
        authService.setSession(tokenObj);
        token = tokenObj.accessToken;
      }
    } catch (error) {
      // This call is causing Maximum update depth exceeded error. Disabling for now.
      // Should test with server terminating due to inactivity.
      // Disable using !error is intentional
      if (logoutOnError && !error) {
        logoutOnError(error);
      }
      dispatch(stopAction());
      authService.setSession(null);
      return null;
    }
  }

  try {
    const headers = {
      Authorization: token ? `Bearer ${token}` : null,
    };

    // Set Content-Type based on the type
    if (type === 'form-data') {
      headers['Content-Type'] = 'multipart/form-data';
    } else {
      headers['Content-Type'] = 'application/json'; // Default
    }

    const responseType = type === 'blob' ? 'blob' : 'json';

    const config = {
      method,
      url: `${API_BASE_URL}${url}`,
      headers,
      responseType,
      data
    };

    // if (type === 'blob') {
    //   if (method === 'post') {
    //     config.onUploadProgress = function (processEvent) {
    //       const percentCompleted = Math.round((processEvent.loaded * 100) / processEvent.total);
    //       console.log(`Upload: ${percentCompleted}`);
    //     };
    //   } else if (method === 'get') {
    //     config.onDownloadProgress = function (processEvent) {
    //       const percentCompleted = Math.round((processEvent.loaded * 100) / processEvent.total);
    //       console.log(`Download: ${percentCompleted}`);
    //     };
    //   }
    // }

    axios.defaults.withCredentials = true;
    const response = await axios(config);
    if (type === 'blob') {
      const [, filename] = response.headers['content-disposition'].split('filename=');
      return { blob: response.data, filename };
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.detail || error.message;
    throw (message);
  } finally {
    dispatch(stopAction());
  }
};

class AxiosService {
  get = (url) => callAxios('get', url);

  put = (url, data) => callAxios('put', url, data);

  post = (url, data) => callAxios('post', url, data);

  delete = (url) => callAxios('delete', url);

  getBlob = (url) => callAxios('get', url, null, 'blob');

  postBlob = (url, data) => callAxios('post', url, data, 'blob');

  postFormData = (url, data) => callAxios('post', url, data, 'form-data');
}

const axiosService = new AxiosService();
export default axiosService;
